import { useRef } from 'react';
import TransitionStylesContext from './TransitionStylesContext';
import TransitionStylesManager from './TransitionStylesManager';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TransitionStylesProvider({
  children
}) {
  const managerRef = useRef(new TransitionStylesManager());
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react-hooks/refs
    _jsx(TransitionStylesContext.Provider, {
      value: managerRef.current,
      children: children
    })
  );
}